<div class="content-loader" *ngIf="type=='content'"></div>
<div class="cover-loader" *ngIf="type=='cover'"></div>
<div class="landing-loader" *ngIf="type=='landing'"></div>